import React, { useEffect, useState,useRef } from "react";
import { styled, useTheme } from "@mui/material/styles";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import SearchIcon from "@mui/icons-material/Search";
import CallMadeIcon from "@mui/icons-material/CallMade";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import Tooltip from '@mui/material/Tooltip';
import countries from 'i18n-iso-countries'; // Import countries
import enLocale from 'i18n-iso-countries/langs/en.json'; // Import English locale
import { Link, useNavigate } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
// import "./BussinessAgentCss/dashboard.css"

import {
  Button,
  Divider,
  Fade,
  FormControl,
  Grid,
  InputAdornment,
  Menu,
  MenuItem,
  Modal,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import axios from "axios";
import {
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import { authToken, getAssignDriverId } from "../../redux/reducers/login";
import { authToken} from "../../redux/reducers/login";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { paths } from "../../config/constants";

countries.registerLocale(enLocale);

// const PaperWrapper = styled(Paper)((props) => ({
//   p: {
//     fontStyle: "normal",
//     fontWeight: "500",
//     fontSize: "16px",
//     lineHeight: "15px",
//     color: "#97ADBE",
//     backgroundColor: "#FFFFFF",
//     padding: "8px 0px 0px 9px",
//   },
//   borderBottom: props?.borderBottom,
//   ".number": {
//     fontSize: "40px",
//     lineHeight: "52px",
//     color: "#1F3648",
//     padding: "4px 8px",
//   },

//   ".smallNumber": {
//     fontWeight: "700",
//     fontSize: "12px",
//     lineHeight: "16px",
//     color: "#2FA804",
//   },
//   ".circle": {
//     background: "#FFFFFF",
//     border: "1px solid #F8F8F8",
//     boxShadow: "0px 4px 4px - 3px rgba(0, 0, 0, 0.25)",
//     borderRadius: "50%",
//     padding: "10px",
//     margin: "0px 29px 15px 1px",
//   },
// }));

const FilterWrapper = styled(Grid)({
  "@media (min-width: 1200px)": {
    ".filter-box": {
      maxWidth: "12.50%",
      textAlign: "left",
    },
  },
});
const TableCellWraper = styled(TableCell)(() => ({
  textAlign: "left",
  fontstyle: "normal",
  fontWeight: 500,
  fontSize: "15px",
  lineHeight: " 20px",
  color: "#000000",
}));

const BodyTableCellWraper = styled(TableCell)(() => ({
  textAlign: "left",
  fontstyle: "normal",
  fontWeight: 500,
  fontSize: "15px",
  lineHeight: " 20px",
  color: "#000000",
}));
export default function Dashboard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  const [openData, setOpenData] = React.useState(false);
  const [data, setData] = useState([]);
  // eslint-disable-next-line
  const [role, setRole] = useState(1);
  const [rolee, setRolee] = useState("");
  const [search, setSearch] = useState("");
  const [payment, setPayment] = useState("");
  const [valeDropdown, setValeDropdown] = useState("");
  // eslint-disable-next-line 
  const [postsPerPage, setPostsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [countryList, setCountryList] = useState([]);
  const [country, setCountry] = useState("");
  const [countryiso, setCountryiso] = useState("");
  const [stateList, setStateList] = useState([]);
  const [state, setState] = useState("");
  const [stateiso, setStateiso] = useState("");
  const [cityList, setCityList] = useState([]);
  const [city, setCity] = useState("");
  const [status, setStatus] = useState("");
  const [allData, setAllData] = useState([]);
  const [journeyDate, setJourneyDate] = useState();
  const [journeyDate1, setJourneyDate1] = useState();
  const [reasonOpen, setReasonOpen] = useState(false);
  const[undoCancel,setUndoCancel]=useState(false);
  const [reason, setReason] = useState('');
  const loginRole = useSelector(authToken);
  const logingUser = useSelector((state) => state);
  const token = logingUser.login.token
  const currentRole = localStorage.getItem("userRole");
  const fName = localStorage.getItem("fname");
  const lName = localStorage.getItem("lname");
  const [formattedUTCDate, setFormattedUTCDate] = useState("");
  const [unixTimestamp, setUnixTimestamp] = useState(null);
  const [currentMonthBookings, setCurrentMonthBookings] = useState([]);

  const loginRoles = loginRole?.payload?.login?.user?.data?.role
  const userID=localStorage.getItem('_id')
  console.log("journeyDate", journeyDate);
  const filteredData = data?.filter((curElem) => {
    const matchesSearch =
      search === "" ||
      Object.values(curElem).some((value) =>
        value?.toString().toLowerCase().includes(search.toLowerCase())
      );
    const matchesStatus = payment === "" || curElem.paymentType === payment;

    return matchesSearch && matchesStatus;
  });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const menuOpen = Boolean(menuAnchorEl);
  const menuContainerRef = useRef(null);
  let accountType=localStorage.getItem("accountType");

  let toastId1 = null;
  let toastId2 = null;

  const openDownload = Boolean(anchorEl);
  const handleCloseDownload = () => {
    setAnchorEl(null);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const totalPage = Math.ceil(filteredData.length / postsPerPage);

  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentPosts = filteredData?.slice(firstPostIndex, lastPostIndex);

  const [openFilter, setOpenFilter] = React.useState(false);
  const filterOpen = () => setOpenFilter(true);
  const filterClose = () => setOpenFilter(false);

  const handleReset = () => {
    setValeDropdown("");
    setStatus("");
    setPayment("");
    setCountry("");
    setCountryiso("");
    setStateList([]);
    setState("");
    setStateiso("");
    setCityList([]);
    setCity("");
    setJourneyDate()
    setJourneyDate1()
    setOpenData(false);
    fetchCountryList();
    fetchUserData();
  };

  const handleAssign = (data) => {
    //dispatch(getAssignDriverId(data));
    navigate("/admin/assign-driver")
    console.log(data)
  }

  const handleChange = (e) => {
    setValeDropdown(e.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleStatus = (event) => {
    setStatus(event.target.value);
  };

  const fetchUserData = () => {
    axios
      .post(`${process.env.REACT_APP_URL}api/booking/getBusinessAgentBookings`, {
        userID: userID,
      })
      .then(function (res) {
        const sortedBookings = res.data.data
          .map(booking => ({
            ...booking,
            numericBookingId: parseInt(booking.bookingId.replace(/\D/g, ""), 10) // Extract number part
          }))
          .sort((a, b) => b.numericBookingId - a.numericBookingId); // Sort in descending order

        setData(sortedBookings);
        console.log("sortedBookings",sortedBookings);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    fetchUserData();
    // eslint-disable-next-line
  }, [role]);

  useEffect(() => {
    fetchCountryList();
  }, []);

  const fetchCountryList = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL}api/booking/getCountriesList`
      );
      setCountryList(res?.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getStateList = async (e) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}api/booking/getStateList`,
        { countryCode: countryiso }
      );
      setStateList(response?.data.data);
    } catch (error) {
      setStateList([]);
      console.log(error);
    }
  };
  useEffect(() => {
    getStateList();
    getCityList();
    // eslint-disable-next-line
  }, [countryiso]);

  const getCityList = async (e) => {
    try {
      const ress = await axios.post(
        `${process.env.REACT_APP_URL}api/booking/getCityList`,
        { countryCode: countryiso, stateName: stateiso }
      );
      setCityList(ress?.data.result);
    } catch (error) {
      setCityList([]);
      console.log(error);
    }
  };
  useEffect(() => {
    getCityList();
    // eslint-disable-next-line
  }, [stateiso]);
 

  const filterList = async (value) => {
    if (valeDropdown === "") {
      let data = {
        country: country,
        paymentType: payment,
        state: state,
        location: city,
        action: 1,
        userType: rolee,
        bookingStatus: status,
        journeyStartDate: journeyDate,
        journeyEndDate: journeyDate1,
      };
      try {
        const ress = await axios.post(
          `${process.env.REACT_APP_URL}api/booking/companyAgentDashboardFilters`,
          data
        );
        setData(ress?.data?.result.reverse());
        filterClose();
      } catch (error) {
        console.log(error);
        setOpenData(true);
        filterClose();
      }
    } else {
      let data = {
        country: country,
        paymentType: payment,
        state: state,
        location: city,
        action: 1,
        selectDate: valeDropdown,
        bookingStatus: status,
        userType: rolee,
        journeyStartDate: journeyDate,
        journeyEndDate: journeyDate1,
      };

      try {
        const ress = await axios.post(
          `${process.env.REACT_APP_URL}api/booking/companyAgentDashboardFilters`,
          data
        );
        setData(ress?.data?.result.reverse());
        filterClose();
      } catch (error) {
        console.log(error);
        setOpenData(true);
        filterClose();
      }
    }
  };

  const filterListed = async (value) => {
    if (valeDropdown === "") {
      let data = {
        country: country,
        paymentType: payment,
        state: state,
        location: city,
        action: 1,
        userType: value,
        // selectDate:valeDropdown,
        bookingStatus: status,
        journeyStartDate: journeyDate,
        journeyEndDate: journeyDate1,
      };
      try {
        const ress = await axios.post(
          `${process.env.REACT_APP_URL}api/admin/filtersInAdminPannel`,
          data
        );
        console.log("filter", ress.data.result.reverse());
        setData(ress?.data?.result);
      } catch (error) {
        console.log(error);
        setOpenData(true);
        filterClose();
      }
    } else {
      let data = {
        country: country,
        paymentType: payment,
        state: state,
        location: city,
        action: 1,
        selectDate: valeDropdown,
        bookingStatus: status,
        userType: value,
        journeyStartDate: journeyDate,
        journeyEndDate: journeyDate1,
      };

      try {
        const ress = await axios.post(
          `${process.env.REACT_APP_URL}api/admin/filtersInAdminPannel`,
          data
        );
        setData(ress?.data?.result);
      } catch (error) {
        console.log(error);
        setOpenData(true);
        filterClose();
      }
    }
  };
  // let totalPrice = 0;

  // for (let i = 0; i < data.length; i++) {
  //   totalPrice += data[i].price;
  // }

  // const totalPrice = data.reduce((total, item) => {
  //   // Directly use the item.price if it's a number
  //   if (typeof item.price === "number" && !isNaN(item.price)) {
  //     return total + item.price;
  //   } else {
  //     return total;
  //   }
  // }, 0);

  const totalPrice = data.reduce((total, item) => {
    // Directly use the item.price if it's a number
    if (typeof item.price === "number" && !isNaN(item.price)) {
      return total + item.price;
    } else {
      return total;
    }
  }, 0);

  const getSerialNumber = (index) => {
    return (currentPage - 1) * postsPerPage + index + 1;
  };

  const handlePaginationClick = (event, page) => {
    setCurrentPage(page);
  };
  const downloadfile = async (i) => {
    const res = await axios.post(
      `${process.env.REACT_APP_URL}api/admin/dashBoardExports`,
      { exportType: i }
    );
    if (res.status === 200) {
      const download = res?.data?.filePath;
      window.open(download, "_blank");
    }
  };
  const xlsxx = () => {
    downloadfile("1");
    handleCloseDownload();
  };
  const csvv = () => {
    downloadfile("0");
    handleCloseDownload();
  };
  const txtt = () => {
    downloadfile("2");
    handleCloseDownload();
  };

  const fetchBookingDetails = async (bookingId) => {
    let data = {
      bookingId: bookingId,
    };
    setOpen(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/booking/getbookingdetailsbyID`,
        data
      );
      //setContact(res?.data?.data?.booking_contact_infos);
      setAllData(res?.data?.data || []);
      const result = res?.data?.data || [];
    setAllData(result);
    return result; // return data for use
    } catch (error) {
      console.log(error);
    }
  };

  const handleCountry = (event) => {
    const selectedCountry = countryList.find(
      (country) => country.isoCode === event.target.value
    );
    if (selectedCountry) {
      const { isoCode, name } = selectedCountry;
      // console.log(isoCode)
      // console.log(name)
      // countryRef.current = name;
      setCountryiso(isoCode);
      setCountry((prevCountry) => name);
    }
    // setCountry(event.target.value.name);
    // setCountryiso(event.target.value);
    // filterList();
  };
  // useEffect(() => {
  //     filterList();
  // }, [country])
  // useEffect(() => {
  //     filterList();
  // }, [state])
  // useEffect(() => {
  //     filterList();
  // }, [city])

  const handleState = (event) => {
    const selectedState = stateList.find(
      (state) => state.isoCode === event.target.value
    );
    if (selectedState) {
      const { isoCode, name } = selectedState;
      // console.log(isoCode)
      // console.log(name)
      setState(name);
      setStateiso(isoCode);
    }
    // setCountry(event.target.value.name);
    // setCountryiso(event.target.value);
    // setState(event.target.value.name);
    // setStateiso(event.target.value);
    // filterList();
  };

  const handleCity = (event) => {
    const selectedCity = cityList.find(
      (city) => city.name === event.target.value
    );
    if (selectedCity) {
      const { name } = selectedCity;
      // console.log(isoCode)
      console.log(name);
      // setStateiso(isoCode);
      setCity(name);
    }
    // setCountry(event.target.value.name);
    // setCountryiso(event.target.value);
    // setState(event.target.value.name);
    // setStateiso(event.target.value);
    // filterList();
  };
  const roles = (value) => {
    setRolee(value);
    if (value === "") {
      fetchUserData();
    } else {
      filterListed(value);
    }
  };

  const toRoman = (num) => {
    const romanMap = [
      [1000, "M"],
      [900, "CM"],
      [500, "D"],
      [400, "CD"],
      [100, "C"],
      [90, "XC"],
      [50, "L"],
      [40, "XL"],
      [10, "X"],
      [9, "IX"],
      [5, "V"],
      [4, "IV"],
      [1, "I"],
    ];
    let result = "";
    for (const [value, symbol] of romanMap) {
      while (num >= value) {
        result += symbol;
        num -= value;
      }
    }
    return result;
  };
  const handleBookingCancellation=async()=>{////////////////////////////////////////////////

    let cancellationSuffix = "";

    // Append reason based on currentRole
    if (currentRole === "0") {
        cancellationSuffix = " (Cancelled by Admin)";
    } else if (currentRole === "4") {
      cancellationSuffix = ` (Cancelled by Customer Support by ${fName} ${lName})`;
    }
    else if(currentRole=="2" && accountType=="Company"){
      cancellationSuffix = ` (Cancelled by Company by ${fName} ${lName})`;
    } 
    else if(currentRole=="2" && accountType=="Agent"){
      cancellationSuffix = ` (Cancelled by Agent by ${fName} ${lName})`;
    }

    // Ensure a valid reason is always provided
    const updatedReason = reason && reason.trim() !== ""
        ? `${reason.trim()}${cancellationSuffix}`
        : `Cancelled${cancellationSuffix}`;

    const data={
      bookingId:allData[0]?._id,
      cancelStatus:"Cancelled",
      cancellationReason:updatedReason,
    }
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/booking/cancelBookingById`,
        data
      );
      
    } catch (error) {
      console.log(error);
    }
  };
  const handleUndoBookingCancellation=async()=>{
    let cancellationSuffix = "";
    if (currentRole === "0") {
        cancellationSuffix = " Booking cancellation was reverted by Admin.";
    } else if (currentRole === "4") {
      cancellationSuffix = ` (Booking cancellation was reverted by customer support by ${fName} ${lName})`;
    }

    const data={
      bookingId:allData[0]?._id,
      cancelStatus:"",
      cancellationReason:cancellationSuffix,
    }
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/booking/cancelBookingById`,
        data
      );
      
    } catch (error) {
      console.log(error);
    }
  };


  const handleOpen = () => {
    setReasonOpen(true);
  };
  
  const cancelBooking=(id)=>{
    handleOpen()
  };
  
  const undoCancelBooking=(id)=>{
    setUndoCancel(true)
  };

  const handleConfirm = () => {
    if (!reason.trim()) {
      alert("Please provide a reason for cancellation.");
      return;
    }
    setReasonOpen(false);
    setOpen(false);
    handleBookingCancellation();
    fetchUserData();
  };
  const handleUndoConfirm = () => {
    setUndoCancel(false);
    setOpen(false);
    handleUndoBookingCancellation();
    fetchUserData();
  };

  const handleReasonClose = () => {
    setReason(''); // Clear the reason if canceled
    setReasonOpen(false);
  };
 
  const handleMenuClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const Booking=async(id)=>{
    let data={
      id1:id
    }
    const res = await axios.post(
      `${process.env.REACT_APP_URL}api/booking/reSendBookingEmail`,
      data
    );
    handleClose();
  }
  const rideAccept = () => {
    handleClose();
  };

  const rideCompleted = () => {
    handleClose();
  };

  useEffect(() => {
    const now = new Date();

    // Get the UTC date components for formatted date
    const day = now.getUTCDate().toString().padStart(2, '0');
    const month = (now.getUTCMonth() + 1).toString().padStart(2, '0');  // Month is zero-based
    const year = now.getUTCFullYear();

    // Format the date as 'DD-MM-YYYY' in UTC
    const formattedDate = `${day}-${month}-${year}`;

    // Get the Unix timestamp (milliseconds since Unix Epoch in UTC)
    const timestamp = now.getTime();

    // Set the state
    setFormattedUTCDate(formattedDate);
    setUnixTimestamp(timestamp/1000);
  }, []); // Empty dependency array to run on component mount



  const getInvoice = async (bookingId, bookingIdTwo) => {
    const bookingData = await fetchBookingDetails(bookingId);    const now = new Date();
  
  if(bookingData[0]?.status !== "3"){
    if (!toast.isActive(toastId2)) {
      toastId2 = toast.info(
      "Driver has not completed the ride yet",
      { autoClose: 2500 }
      );
    }
    return;
  }

  const day = String(now.getUTCDate()).padStart(2, "0");
  const month = String(now.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = now.getUTCFullYear();

  // const formattedDate = `${day}-${month}-${year}`; // UTC date in "dd-mm-yyyy"
  const hours = String(now.getUTCHours()).padStart(2, "0");
  const minutes = String(now.getUTCMinutes()).padStart(2, "0");

  const formattedDate = `${day}-${month}-${year}`; // UTC date
  const utcUnixTimestampMs = now.getTime();
    let data = {
      bookingId: bookingId,
      bookingIdTwo: bookingIdTwo,
      invoiceDate: formattedDate,
      invoiceDate:utcUnixTimestampMs,
      requestedBy:"admin/Cs"
    };  
  
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}api/driver/invoiceGenerate`,
        data
      );
    } catch (error) {
      toast.info(error.response.data.msg, error.response.data.status);
    }
  }; 

  const notify = (val, type = 200) => {
    if (type == 200) {
      toast.success(val, {autoClose:2500});
    } else {
      toast.error(val, {autoClose:2500});
    }
  };
  const updateBookingStatusByAdmin = async (bookingId, bookingIdTwo, val) => {
    if(!allData[0]?.driverID){
      if (!toast.isActive(toastId1)) {
        toastId1 = toast.info(
        "Please assign a driver to this booking first.",
        { autoClose: 2500 }
        );
      }
    }
    let data = {
      bookingId: bookingId,
      status: val,
      driverID: allData[0]?.driverID,
    };
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`, // replace with your actual token
      // add any other headers you need here
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}api/booking/updateBookingStatus`,
        data,{headers:headers}
      );
      if (response.status === 200 && response.data.status === 200) {
        getInvoice(bookingId, bookingIdTwo);
      }
        
  
    } catch (error) {
      notify(error.response.data.msg, error.response.data.status);
    }
    // getInvoice(allData[0]?._id,allData[0]?.bookingId)}
  };

   const loggedInUser = useSelector((state) => state.login);
   const [employees, setEmployees] = useState([]);
   const [loading, setLoading] = useState(false);
  
    const fetchEmployees = async () => {
      setLoading(true);
      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_URL}api/user/fetchEmployees`,
          {
            companyName: loggedInUser.user.data.companyName,
          }
        );
        setEmployees(data.data);
      } catch (error) {
        console.error("Failed to fetch employees:", error);
        toast.error("Failed to fetch employees.");
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
        fetchEmployees();
      }, []);

  const currentMonth = new Date().toLocaleString('default', {
  month: 'long',
  year: 'numeric',
});

useEffect(() => {
    if (!Array.isArray(data)) return;

    const now = new Date();
    const currentMonth = now.getUTCMonth(); // 0-11
    const currentYear = now.getUTCFullYear();

    const filtered = data.filter(booking => {
      if (!booking?.date) return false;

      const bookingDate = new Date(parseInt(booking.date));

      return (
        bookingDate.getUTCMonth() === currentMonth &&
        bookingDate.getUTCFullYear() === currentYear
      );
    });

    setCurrentMonthBookings(filtered);
    console.log("CurrentMonthBookings",filtered)
  }, [data]);

  return (
    <div className="container-fluid container-main compDashboardTable" style={{margin:"0",}} >
      <Box component="main" sx={{ flexGrow: 1, pt: 2 }} >

<div className="compDashboard-grid">
  {/* First card - always full width */}
  <div className="compDashboard-card full-width compGreen-border ">
    <p>Current Month</p>
    <div className="compNumber">{currentMonth}</div>
  </div>

  {/* Remaining six cards */}
  <div className="compDashboard-card compOrange-border">
    <p>Current Month Booking</p>
    <div className="compNumber">{currentMonthBookings?.length}</div>
  </div>

  <div className="compDashboard-card compPurple-border">
    <p>Cash Booking</p>
    <div className="compNumber">
      {currentMonthBookings.filter(b => b.paymentType === "Cash").length}
    </div>
  </div>

  <div className="compDashboard-card compBlue-border">
    <p>Bank Invoice Booking</p>
    <div className="compNumber">
      {currentMonthBookings.filter(b => b.paymentType === "Bank Invoice").length}
    </div>
  </div>

  <div className="compDashboard-card compDarkblue-border">
    <p>Card Booking</p>
    <div className="compNumber">
      {currentMonthBookings.filter(b => b.paymentType === "Card").length}
    </div>
  </div>

  <div className="compDashboard-card compGreen2-border">
    <p>Total Commission Present Month</p>
    <div className="compNumber">
      {data.filter((item) => item.status === "1").length}
    </div>
  </div>

  <div className="compDashboard-card compRed-border">
    <p>Pending Invoices</p>
    <div className="compNumber">
      {data.filter((item) => item.status === "3").length}
    </div>
  </div>
</div>


        {/* ----------------Details Reports------------------ */}
        <Box className="compDashboardTable2 mt-3" >
         <Paper >
    {/* ====== HEADER ====== */}
    <div className="compPage-header px-3 py-3 mb-4">
      <div>
        <h3 className="page-heading mb-0">
          {accountType === "Company"
            ? "Detailed Company Booking Report"
            : accountType === "Agent"
            ? "Detailed Agent Booking Report"
            : "Detailed Booking Report"}
        </h3>
        <p className="mb-0">All Bookings</p>
      </div>

      <div className="d-flex gap-3">
        {loginRoles === "0" && (
          <Button
            id="fade-button"
            aria-controls={openDownload ? "fade-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={openDownload ? "true" : undefined}
            onClick={handleClick}
            variant="outlined"
          >
            Download
            <FileDownloadIcon
              sx={{ width: 20, height: 18, marginLeft: "3px" }}
            />
          </Button>
        )}
        <Menu
          id="fade-menu"
          MenuListProps={{
            "aria-labelledby": "fade-button",
          }}
          anchorEl={anchorEl}
          open={openDownload}
          onClose={handleCloseDownload}
          TransitionComponent={Fade}
        >
          <MenuItem sx={{ minWidth: "120px" }} onClick={xlsxx}>
            EXCEL
          </MenuItem>
          <MenuItem sx={{ minWidth: "120px" }} onClick={csvv}>
            CSV
          </MenuItem>
          <MenuItem sx={{ minWidth: "120px" }} onClick={txtt}>
            TXT
          </MenuItem>
        </Menu>
      </div>
    </div>

    {/* ====== FILTERS ====== */}
    <FilterWrapper  spacing={2} px={0}>
      <div className="compFilter-row mb-3 px-3">
        <TextField
          className="ps-0 searhTextField"
          size="small"
          fullWidth
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          placeholder="Search"
        />

        <Button variant="contained" onClick={filterOpen}>
          Filters
        </Button>
        <Button variant="outlined" onClick={handleReset}>
          Reset
        </Button>
      </div>
      <div >
                <Modal className="compFilterBox" open={openFilter} onClose={filterClose}>
                  <Box
                    className="compFilterBox2"
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      maxWidth: 600,
                      bgcolor: "background.paper",
                      borderRadius: "10px",
                      boxShadow: 24,
                      p: 2,
                    }}
                  >
                    <h6 className="normal-heading px-3">Filter</h6>
                    <Divider sx={{ borderColor: "black" }} />
                    <div className="row px-3 my-3">
                      <div className="col-md-6 mb-3">
                        <h6 className="select-label">Created:</h6>
                        <FormControl mx={1} fullWidth>
                          <Select
                            size="small"
                            value={valeDropdown}
                            displayEmpty
                            onChange={handleChange}
                            style={{ borderRadius: "5.86877px" }}
                          >
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value={"0"}>Today</MenuItem>
                            <MenuItem value={"1"}>Yesterday</MenuItem>
                            <MenuItem value={"2"}>Last 7 Days</MenuItem>
                            <MenuItem value={"3"}>Month</MenuItem>
                            <MenuItem value={"4"}>Year</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      <div className="col-md-6 mb-3">
                        <h6 className="select-label">Journey Date</h6>
                        <FormControl mx={1} fullWidth>
                         
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div style={{ display: "flex", gap: "16px" }}>
        <MobileDatePicker
          label="Journey Start"
          format="DD/MM/YYYY"
          value={journeyDate ? dayjs(journeyDate) : null}
          onChange={(newValue) =>
            setJourneyDate(newValue ? newValue.valueOf() : null)
          }
          ampm={false}
        />

        <MobileDatePicker
          label="Journey End"
          format="DD/MM/YYYY"
          value={journeyDate1 ? dayjs(journeyDate1) : null}
          onChange={(newValue) =>
            setJourneyDate1(newValue ? newValue.valueOf() : null)
          }
          minDateTime={journeyDate ? dayjs(journeyDate) : undefined} // 👈 ensures end >= start
          ampm={false}
        />
      </div>
    </LocalizationProvider>
                        </FormControl>
                      </div>
                      <div className="col-md-6 mb-3">
                        <h6 className="select-label">Booking Status</h6>
                        <FormControl fullWidth size="small">
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            size="small"
                            value={status}
                            displayEmpty
                            onChange={handleStatus}
                            style={{ borderRadius: "5.86877px" }}
                          >
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value={"0"}>Open</MenuItem>
                            <MenuItem value={"1"}>Accepted</MenuItem>
                            <MenuItem value={"2"}>Processing</MenuItem>
                            <MenuItem value={"3"}>Completed</MenuItem>
                            <MenuItem value={"4"}>No Show</MenuItem>
                            <MenuItem value={"5"}>Completed</MenuItem>
                            <MenuItem value={"6"}>Refunded</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      <div className="col-md-6 mb-3">
                        <h6 className="select-label">Payment Status</h6>
                        <FormControl fullWidth size="small">
                          <Select
                            value={payment}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            size="small"
                            displayEmpty
                            onChange={(e) => setPayment(e.target.value)}
                            style={{ borderRadius: "5.86877px" }}
                          >
                            <MenuItem value={""}>All</MenuItem>
                            <MenuItem value={"Cash"}>Cash</MenuItem>
                            <MenuItem value={"Card"}>Card</MenuItem>
                            <MenuItem value={"Bank Invoice"}>Bank Invoice</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      <div className="col-md-6 mb-3">
                        <h6 className="select-label">Country</h6>
                        <FormControl fullWidth size="small">
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            size="small"
                            value={countryiso}
                            displayEmpty
                            onChange={handleCountry}
                            style={{ borderRadius: "5.86877px" }}
                          >
                            <MenuItem value="">Select Country</MenuItem>
                            {countryList?.length > 0 &&
                              countryList?.map((currentValue) => {
                                return (
                                  <MenuItem value={currentValue.isoCode}>
                                    {currentValue.name}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                        </FormControl>
                      </div>
                      <div className="col-md-6 mb-3">
                        <h6 className="select-label">State</h6>
                        <FormControl fullWidth size="small">
                          <Select
                            size="small"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={stateiso}
                            displayEmpty
                            onChange={handleState}
                            style={{ borderRadius: "5.86877px" }}
                          >
                            <MenuItem value="">Select State</MenuItem>
                            {countryList.length === 0 ||
                            stateList.length === 0 ? (
                              <MenuItem disabled>No state available</MenuItem>
                            ) : (
                              stateList?.length > 0 &&
                              stateList?.map((currentValue, i) => {
                                return (
                                  <MenuItem
                                    key={i}
                                    value={currentValue.isoCode}
                                  >
                                    {currentValue.name}
                                  </MenuItem>
                                );
                              })
                            )}
                          </Select>
                        </FormControl>
                      </div>
                      <div className="col-md-6 mb-3">
                        <h6 className="select-label">City</h6>
                        <FormControl fullWidth size="small">
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            size="small"
                            displayEmpty
                            value={city}
                            onChange={handleCity}
                            style={{ borderRadius: "5.86877px" }}
                          >
                            <MenuItem value="">Select City</MenuItem>
                            {countryList.length === 0 ||
                            stateList.length === 0 ||
                            cityList.length === 0 ? (
                              <MenuItem disabled>No city available</MenuItem>
                            ) : (
                              cityList?.length > 0 &&
                              cityList?.map((currentValue, i) => {
                                return (
                                  <MenuItem value={currentValue.name}>
                                    {currentValue.name}
                                  </MenuItem>
                                );
                              })
                            )}
                          </Select>
                        </FormControl>
                      </div>

                      
                      <div className="col-12 my-1">
                        <div className="d-flex justify-content-center">
                          <Button
                            variant="outlined"
                            className=""
                            style={{ width: "100px" }}
                            onClick={() => {
                              filterList();
                            }}
                          >
                            Apply Filter
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Box>
                </Modal>
              </div>
              <Dialog
                open={openData}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  {"No Data Found, Reset FIlters"}
                </DialogTitle>
                <DialogActions>
                  <Button onClick={handleReset}>Reset</Button>
                </DialogActions>
              </Dialog>
      
    </FilterWrapper>

    {/* ====== TABLE ====== */}
    <div className="compTable-responsive p-3">
      <Table>
        <TableHead
          style={{
            backgroundColor: "#FBFAFA",
            borderBottom: "1px solid #F0F0F0",
          }}
        >
          <TableRow>
            <TableCellWraper>Sr. No.</TableCellWraper>
            <TableCellWraper className="text-nowrap">Booking ID</TableCellWraper>
            <TableCellWraper className="text-nowrap">Pickup Date & Time</TableCellWraper>
            <TableCellWraper className="text-nowrap">Ride Status</TableCellWraper>
            {accountType === "Company" && (
              <TableCellWraper className="text-nowrap">Employee Id</TableCellWraper>
            )}
            <TableCellWraper className="text-nowrap">Booking For</TableCellWraper>
            <TableCellWraper className="text-nowrap">Payment Type</TableCellWraper>
            <TableCellWraper className="text-nowrap">Total Payment</TableCellWraper>
            <TableCellWraper className="text-nowrap">Cancel Reason</TableCellWraper>
          </TableRow>
        </TableHead>

        <TableBody>
          {currentPosts?.map((curElem, i) => {
            const totalItems = data.length;
            const serialNumber =
              totalItems - (currentPage - 1) * postsPerPage - i;

            return (
              <TableRow key={curElem?._id}>
                <TableCell>{serialNumber}</TableCell>
                <BodyTableCellWraper
                component="th"
                          scope="row"
                          onClick={(e) => fetchBookingDetails(curElem?._id)}>
                  
                  <Link
                    to=""
                    className="text-decoration-none text-nowrap"
                    style={{ color: "#0072CB" }}
                  >
                    {curElem.bookingId}
                  </Link>
                </BodyTableCellWraper>
                <BodyTableCellWraper className="text-nowrap">
                  {new Intl.DateTimeFormat("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                    timeZone: "UTC",
                  }).format(parseInt(curElem?.date))}
                </BodyTableCellWraper>
                <BodyTableCellWraper>
                  {curElem?.failStatus === "Failed"
                    ? "Failed"
                    : curElem?.cancelStatus === "Cancelled"
                    ? "Cancelled"
                    : curElem?.status === "0"
                    ? "Pending"
                    : curElem?.status === "1"
                    ? "Accepted"
                    : curElem?.status === "2"
                    ? "Processing"
                    : curElem?.status === "3"
                    ? "Completed"
                    : curElem?.status === "4"
                    ? "No Show"
                    : curElem?.status === "5"
                    ? "On Spot Cancel"
                    : curElem?.status === "6"
                    ? "Refunded"
                    : ""}
                </BodyTableCellWraper>

                {accountType === "Company" && (
                  <BodyTableCellWraper>
                    {employees?.find(
                      (emp) =>
                        emp?._id?.toString() === curElem?.employeeId?.toString()
                    )?.id || "N/A"}
                  </BodyTableCellWraper>
                )}

                <BodyTableCellWraper>
                  {accountType === "Agent" ? (
                    <span>Customer</span>
                  ) : (
                    <span>
                      {employees?.some(
                        (emp) =>
                          emp?._id?.toString() ===
                          curElem?.employeeId?.toString()
                      )
                        ? "Employee"
                        : "Customer"}
                    </span>
                  )}
                </BodyTableCellWraper>

                <BodyTableCellWraper>
                  {curElem?.paymentType || "N/A"}
                </BodyTableCellWraper>

                <BodyTableCellWraper>
                  {parseFloat(curElem?.total).toFixed(2)} €
                </BodyTableCellWraper>

                <Tooltip
                  title={curElem?.cancellationReason || "N/A"}
                  arrow
                >
                  <BodyTableCellWraper
                    style={{
                      maxWidth: "150px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {curElem?.cancellationReason || "N/A"}
                  </BodyTableCellWraper>
                </Tooltip>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

      {/* Pagination */}
      <div className="w-100 d-flex justify-content-end mt-4 mb-2">
        <Pagination
          count={totalPage}
          page={currentPage}
          onChange={handlePaginationClick}
          color="primary"
        />
      </div>
    </div>
  </Paper>

        </Box>
      </Box>

      <Dialog
        // fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth={"lg"}
        className="compHyperLink"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="d-flex justify-content-between ride-color p-1 m-0"
        >
          <div
            className="d-grid align-items-center compRide-header"
            style={{
              display: "grid",
              gridTemplateColumns: "2fr 1fr", // default single column
            }}
          >
            <p className="text-white fw-bold text-center">{allData[0]?.bookingId}</p>
            <p className="text-white text-center fw-bold">Created at:{" "}
              {new Date(allData[0]?.createdAt).toLocaleString("en-GB", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              })}</p>
            <p className="text-white fw-bold text-center">Driver Name:{" "}
              {allData[0]?. driverName
                ? `${allData[0]?.driverName}`
                : "Not Assigned"}</p>
            <p className="text-white fw-bold text-center">Vehicle No:{" "}
              {allData[0]?.vehicalNumber
                ? `${allData[0]?.vehicalNumber}`
                : "Not Assigned"}</p>
          </div>
          <div>
            <IconButton aria-label="delete" onClick={handleClose}>
              <CancelIcon sx={{ color: "#fff" }} />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent className="p-1">
          {allData[0]?.booking_contact_infos.map((data) => {
            return (
              <div className="border-top">
                <div className="ride-color text-white fw-bold py-1 ps-4">
                  <span>Customer Details</span>
                </div>
                <div className="row">
                  {/* ✅ Show Employee Name column only if employees exist */}
                  {employees?.length > 0 && (
                    <div className="col-3 border nextLine">
                      <div className="fw-bold">Employee Name</div>
                      <div>
                        {
                          employees?.find(
                            emp => emp?._id?.toString() === allData[0]?.employeeId?.toString()
                          )?.id || "N/A"
                        }
                      </div>
                    </div>
                  )}

                  {/* ✅ Adjust column size based on whether employees exist */}
                  <div className={`${employees?.length > 0 ? "col-3" : "col-4"} border nextLine`}>
                    <div className="fw-bold">Name</div>
                    <div>
                      {data?.fName}&nbsp;{data?.lName}
                    </div>
                  </div>

                  <div className={`${employees?.length > 0 ? "col-3" : "col-4"} border nextLine`}>
                    <div className="fw-bold">Email</div>
                    <div>{data?.email}</div>
                  </div>

                  <div className={`${employees?.length > 0 ? "col-3" : "col-4"} border nextLine`}>
                    <div className="fw-bold">Phone</div>
                    <div>{data?.phoneNumber}</div>
                  </div>
                </div>

                <div className="ride-color text-white fw-bold py-1 ps-4">
                  <span>Customer Billing Details</span>
                </div>
                <div className="row">
                  <div className="col-3 border nextLine">
                    <div className="fw-bold">Company Name</div>
                    <div>
                      {data?.companyName||"N/A"}
                    </div>
                  </div>

                  <div className="col-3 border nextLine">
                    <div className="fw-bold">Tax Number</div>
                    <div>{data?.taxNumber|| "N/A"}</div>
                  </div>

                  <div className="col-3 border nextLine">
                    <div className="fw-bold">Country</div>
                    <div>{data?.countryName || 'N/A'}</div>
                  </div>

                  <div className="col-3 border nextLine">
                    <div className="fw-bold">State/Region</div>
                    <div>{data?.stateName || 'N/A' }</div>
                  </div>
                  <div className="col-3 border nextLine">
                    <div className="fw-bold">City</div>
                    <div>{data?.city || 'N/A' }</div>
                  </div>
                  <div className="col-3 border nextLine">
                    <div className="fw-bold">House Number</div>
                    <div>{data?.houseNumber || 'N/A' }</div>
                  </div>
                  <div className="col-3 border nextLine">
                    <div className="fw-bold">Street Name</div>
                    <div>{data?.street || 'N/A' }</div>
                  </div>
                  <div className="col-3 border nextLine">
                    <div className="fw-bold">Postal Code</div>
                    <div>{data?.postalCode || 'N/A' }</div>
                  </div>
                </div>
              </div>
            );
          })}
          <div className="border-top">
            <div className="ride-color text-white fw-bold  py-1 ps-4">
              <span>Ride Details</span>
            </div>
            <div className="row">
              <div className="col-6 border nextLine">
                <div className="fw-bold">Ride Date & Time</div>
                <div>
  {(() => {
    const dateValue = Number(allData[0]?.date);  // Ensure it's a number
    if (isNaN(dateValue)) {
      return "Invalid date";  // You can display a fallback value if the date is invalid
    }
    
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit", // Ensures two-digit month
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: "UTC", // Ensures UTC format
    }).format(dateValue);
  })()}
</div>

              </div>
              <div className="col-6 border nextLine">
                <div className="fw-bold">Return Date & Time</div>
                {allData[0]?.bookingType === "Return" &&
                allData[0]?.returnDate ? (
                  <div>
                  {(() => {
                    const dateValue = Number(allData[0]?.returnDate);  // Ensure it's a number
                    if (isNaN(dateValue)) {
                      return "Invalid date";  // You can display a fallback value if the date is invalid
                    }
                    
                    return new Intl.DateTimeFormat("en-GB", {
                      day: "2-digit",
                      month: "2-digit", // Ensures two-digit month
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                      timeZone: "UTC", // Ensures UTC format
                    }).format(allData[0]?.returnDate);
                  })()}
                </div>
                ) : (
                  <div>N/A</div>
                )}
              </div>
            </div>
          </div>

          <div className="border-top">
            <div className="row">
              <div className="col-6 border-end nextLine">
                <div className="ps-5 pt-5">
                  <div>Route</div>
                  <p className="mt-3">1. {allData[0]?.fromLocation}</p>
                  <p>2 .{allData[0]?.toLocation}</p>
                </div>
              </div>

              <div className="col-6">
                <div className="row">
                  <div className="col-6 border nextLine">
                    <div className="fw-bold">Ride type</div>
                    <div>{allData[0]?.bookingType}</div>
                  </div>

                  {allData[0]?.vehicaltypes.map((item) => {
                    return (
                      <div className="col-6 border nextLine">
                        <div className="fw-bold">Vehicle type</div>
                        <div>{item?.vehicalStandard}</div>
                      </div>
                    );
                  })}

                  <div className="col-6 border nextLine">
                    <div className="fw-bold">Distance</div>
                    <div>{allData[0]?.distance} KM</div>
                  </div>

                  <div className="col-6 border nextLine">
                    <div className="fw-bold">Duration</div>
                    <div>{allData[0]?.time}</div>
                  </div>

                  <div className="col-6 border nextLine">
                    <div className="fw-bold">Flight No</div>
                    <div>{allData[0]?.flightNumber}</div>
                  </div>

                  <div className="col-6 border nextLine">
                    <div className="fw-bold">Extra Time</div>
                    <div>{allData[0]?.extraTime}</div>
                  </div>

                  <div className="col-6 border nextLine">
                    <div className="fw-bold">Payment Type</div>
                    <div>{allData[0]?.paymentType}</div>
                  </div>
                  <div className="col-6 border nextLine">
                    <div className="fw-bold">WhatsApp</div>
                    <div>
                      {allData[0]?.booking_contact_infos[0]?.whatsAppCheck
                        ? "Checked"
                        : "Unchecked"}
                    </div>
                  </div>
                  {allData[0]?.booking_contact_infos.map((data) => {
                    return (
                      <div className="col border nextLine">
                        <div className="fw-bold">Comments</div>
                        <div>
                          {data?.typeAnything
                            ? data.typeAnything
                            : "No Comments"}
                        </div>
                      </div>
                    );
                  })}
                  <div className="col border nextLine">
                      <div className="fw-bold">Customer Invoice</div>
                      {allData?.[0]?.cancelStatus === "Cancelled" ? (
                    <span>Ride Canceled</span>
                  ) : allData?.[0]?.customerInvoiceURL ? (
                      <div>
                        <a
                          href={allData[0].customerInvoiceURL}
                          download
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <InsertDriveFileIcon
                            style={{ cursor: "pointer", color: "#0b2d48" }}
                          />
                        </a>
                      </div>
                  ) : (
                    <span>Yet to Complete</span>
                  )}
                    </div>
                </div>
              </div>
            </div>
          </div>

          {/* {allData[0]?.booking_extra_services?.length > 0 && (
            <div className="border-top">
              <div className="ride-color text-white fw-bold  py-1 ps-4">
                <span>Booking Extra</span>
              </div>

              {allData[0]?.booking_extra_services.map((item) => (
                <div className="row">
                  <div className="col-3 border">
                    <div className="fw-bold">Category</div>
                    <div>{item?.category}</div>
                  </div>

                  <div className="col-3 border">
                    <div className="fw-bold">Quantity</div>
                    <div>{item?.number}</div>
                  </div>

                  {/* <div className="col-3 border-end">
                                                <div className="fw-bold">Payable Fare</div>
                                                <div>{parseInt(allData?.price).toFixed(2)} €</div>
                                            </div>

                                            <div className="col-3 border-end">
                                                <div className="fw-bold">Margin Earned</div>
                                                <div> €</div>
                                            </div> 
                </div>
              ))}
            </div>
          )} */}
          <div className="border-top">
            <div className="ride-color text-white fw-bold py-1 ps-4">
              <span>Booking Extra Options</span>
            </div>
          </div>
          {allData?.[0]?.booking_extra_services?.length > 0 ? (
            <div className="border-top">
              <div className="row">
                {allData[0].booking_extra_services.map((service, index) => {
                  // Find matching extra option details
                  const matchedOption = allData?.[0]?.getExtraOption.find(
                    (option) => option._id === service.serviceId
                  ) || { type: "Unknown", desc: "No details available" };

                  return (
                    <div className="col-12 border" key={service._id}>
                      <div className="row py-1">
                        {/* Display Roman numeral as serial number */}
                        <div className="col-2 fw-bold">
                          {toRoman(index + 1)}:
                        </div>
                        <div className="col-10">
                          <b>{service?.number}</b>&nbsp;<b>X</b>&nbsp;
                          <b>{matchedOption?.type}</b>&nbsp;
                          {matchedOption?.desc}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <p>No extra services chosen.</p>
          )}
          {/* {allData[0]?.extraOptiontotal !== 0 && (
            <div className="col-12 border">
              <div className="row py-1">
              <div className="col-2">
                <div className="fw-bold">Total Extra Option:</div>
              </div>
              <div className="col-10">
                <div>{allData[0]?.extraOptiontotal} <b>€</b></div>
              </div>
            </div>
            </div>
            
          )} */}

          <div className="border-top">
            <div className="ride-color text-white fw-bold  py-1 ps-4">
              <span>Fare</span>
            </div>

            <div className="row">
              {/* <div className="col-3 border-end nextLine">
                <div className="fw-bold">Price Rule Applied</div>
                <div>{allData[0]?.priceRuleApplied}</div>
              </div> */}
              <div className="col-3 border-end nextLine">
                <div className="fw-bold">Ride Fare</div>
                <div>{allData[0]?.price} €</div>
              </div>
              <div className="col-3 border-end nextLine">
                <div className="fw-bold">Extra Option Fare</div>
                <div>{(allData[0]?.extraOptiontotal || 0).toFixed(2)} €</div>
              </div>
              <div className="col-3 border-end nextLine">
                <div className="fw-bold">Applied Tax</div>
                <div>{(allData[0]?.tax || 0).toFixed(2)} €</div>
              </div>
              <div className="col-3 border-end nextLine">
                <div className="fw-bold">Total Fare</div>
                <div>{(allData[0]?.total || 0).toFixed(2)} €</div>
              </div>
              {/* <div className="col-3 border-end">
                <div className="fw-bold">Margin Earned</div>
                <div> €</div>
              </div> */}
            </div>
          </div>

<Box className="my-5 d-flex flex-wrap gap-3 justify-content-between compHyperlinkButton" >
  {/* Conditionally rendered buttons */}
  {allData[0]?.failStatus !== "Failed" && allData[0]?.status !== "3" && (
    <>
      {/* <Button
        variant="contained"
        style={{ width: "200px" }}
        onClick={() => handleAssign(allData[0]._id)}
      >
        Assign Driver
      </Button> */}

      {/* <Button
        variant="contained"
        style={{ width: "200px" }}
        onClick={() =>
          allData[0]?.cancelStatus === "Cancelled"
            ? undoCancelBooking(allData[0]._id)
            : cancelBooking(allData[0]._id)
        }
      >
        {allData[0]?.cancelStatus === "Cancelled"
          ? "Undo Cancel Booking"
          : "Cancel Booking"}
      </Button> */}

      {/* {dayjs(Number(allData[0]?.date)).subtract(24, "hour").isAfter(dayjs()) && (
  <Button
    variant="contained"
    style={{ width: "200px" }}
    onClick={() => {
      const targetPath =
        accountType === "Company"
          ? paths.company.editBussinessBooking
          : paths.businessAgent.editBussinessBooking;

      navigate(targetPath, {
        state: {
          id: allData[0]._id,
          paymentType: allData[0]?.paymentType,
        },
      });
    }}
  >
    Edit Booking
  </Button>
)} */}

{/* {(() => {
  const dateValue = Number(allData[0]?.date); // booking timestamp in ms
  if (isNaN(dateValue)) return false; // invalid date = don't show button

  // booking date in ms
  const bookingDate = new Date(dateValue);

  // cutoff = 24h before booking
  const cutoff = new Date(bookingDate.getTime() - 24 * 60 * 60 * 1000);

  // now
  const now = new Date();

  // show button only if current time < cutoff
  return now < cutoff;
})() && (
  <Button
    variant="contained"
    style={{ width: "200px" }}
    onClick={() => {
      const targetPath =
        accountType === "Company"
          ? paths.company.editBussinessBooking
          : paths.businessAgent.editBussinessBooking;

      navigate(targetPath, {
        state: {
          id: allData[0]._id,
          paymentType: allData[0]?.paymentType,
        },
      });
    }}
  >
    Edit Booking
  </Button>
)} */}

{/* {(() => {
  const dateValue = Number(allData[0]?.date); // ensure it's a number (ms)
  if (isNaN(dateValue)) return false;

  const bookingDate = new Date(dateValue);
  const cutoff = new Date(bookingDate.getTime() - 24 * 60 * 60 * 1000);
  const now = new Date();

  console.log({
    bookingDate: bookingDate.toString(),
    cutoff: cutoff.toString(),
    now: now.toString(),
    shouldShow: now < cutoff
  });
  console.log("now < cutoff:",now,"<",cutoff)
  return now < cutoff; // only show if current time is BEFORE cutoff
})() && (
  <Button
    variant="contained"
    style={{ width: "200px" }}
    onClick={() => {
      const targetPath =
        accountType === "Company"
          ? paths.company.editBussinessBooking
          : paths.businessAgent.editBussinessBooking;

      navigate(targetPath, {
        state: {
          id: allData[0]._id,
          paymentType: allData[0]?.paymentType,
        },
      });
    }}
  >
    Edit Booking
  </Button>
)} */}

{(() => {
  const bookingUtcMs = Number(allData[0]?.date); // booking UTC ms
  if (isNaN(bookingUtcMs)) return false;

  // cutoff = booking - 24h
  const cutoffMs = bookingUtcMs - 24 * 60 * 60 * 1000;

  // get system time in UTC
  const nowUtcMs = Date.now();

  // find user's timezone offset in ms
  const tzOffsetMs = new Date().getTimezoneOffset() * 60 * 1000;

  // adjust: UTC + offset → user local in ms
  const nowLocalAlignedMs = nowUtcMs - tzOffsetMs;

  // compare
  const shouldShow = nowLocalAlignedMs < cutoffMs;

  console.log({
    bookingUtc: new Date(bookingUtcMs).toISOString(),
    cutoffUtc: new Date(cutoffMs).toISOString(),
    nowUtc: new Date(nowUtcMs).toISOString(),
    tzOffsetMs,
    nowLocalAligned: new Date(nowLocalAlignedMs).toString(),
    shouldShow
  });

  return shouldShow;
})() && (
  <Button
    variant="contained"
    style={{ width: "200px" }}
    onClick={() => {
      const targetPath =
        accountType === "Company"
          ? paths.company.editBussinessBooking
          : paths.businessAgent.editBussinessBooking;

      navigate(targetPath, {
        state: {
          id: allData[0]._id,
          paymentType: allData[0]?.paymentType,
        },
      });
    }}
  >
    Edit Booking
  </Button>
)}






      {/* {loginRoles == 0 && (<Button
        variant="contained"
        style={{ width: "200px" }}
        onClick={() => {updateBookingStatusByAdmin(allData[0]?._id,allData[0]?.bookingId,3); }}
      >
        Complete Booking
      </Button>)} */}
    </>
  )}
  {/* {allData[0]?.failStatus !== "Failed" && (<Box>
    <Button
    variant="contained"
    style={{ width: "200px" }}
    onClick={handleMenuClick}
    endIcon={
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          transition: 'transform 0.3s ease',
          transform: menuOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        }}
      >
        <KeyboardArrowDownIcon />
      </Box>
    }
  >
    Resend Email
  </Button>

  <Menu
    anchorEl={menuAnchorEl}
    open={menuOpen}
    onClose={handleMenuClose}
    container={menuContainerRef.current} // keeps inside dialog
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    slotProps={{
      paper: {
        sx: {
          mt: 1,
          maxHeight: "10vw",
          overflowY: 'auto',
        },
      },
    }}
  >
    <MenuItem onClick={() => Booking(allData[0]?._id)}>Reservation Email</MenuItem>
    <MenuItem onClick={() => getInvoice(allData[0]?._id, allData[0]?.bookingId)}>Ride Completed</MenuItem>
  </Menu>
    
  </Box>
  )} */}
</Box>
<Box height="5vw" /> {/* spacer div dont remove */}
        </DialogContent>
      </Dialog>

      <Dialog open={reasonOpen} onClose={handleReasonClose}>
        <DialogTitle>Cancel Booking</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Reason for Cancellation"
            type="text"
            fullWidth
            multiline
            rows={4}
            value={reason}
            onChange={(e) => {
              if (e.target.value.length <= 500) {
                setReason(e.target.value);
              }
            }}
            placeholder="Enter your reason (max 500 characters)"
            helperText={`${reason.length}/500`}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReasonClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirm} color="secondary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={undoCancel} onClose={handleReasonClose}>
        <DialogTitle>
          Are you sure you want to undo the cancellation of this booking?
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleReasonClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleUndoConfirm} color="secondary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
